import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { IStatement } from '../../../model/statement'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import fetchReactions from './fetch-reactions'
import setStatementQuery from '@/store/statement/actions/set-statement-query';

export default async function jybeStatement(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementUtils.statementService.jybe(statement).then((result: any) => {
        const form = statementStore.state.statementSearchForm

        if(form.consideredByMe || form.ignoredByMe || form.notReactedByMe) {
            setStatementQuery(context)
        }
        
        fetchReactions(context, statement)
    })

    return
}
